import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { env } from '../config/env';
import { useSelector } from 'react-redux';

const HomePage = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return (
    <Box>
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Welcome to {env.appTitle}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          A modern React application with Redux, Material UI, and React Router
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3, justifyContent: 'center' }}>
        <Box 
          sx={{ 
            p: 3, 
            flex: 1, 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            boxShadow: 1
          }}
        >
          <Typography variant="h5" component="h2" gutterBottom>
            React Router
          </Typography>
          <Typography paragraph align="center">
            Navigate between pages with React Router v7, the latest version of the most popular routing library for React.
          </Typography>
          <Button
            component={RouterLink}
            to="/about"
            variant="contained"
            color="primary"
            sx={{ mt: 'auto' }}
          >
            Go to About
          </Button>
        </Box>

        {isAuthenticated && (
          <Box 
            sx={{ 
              p: 3, 
              flex: 1, 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center',
              border: '1px solid #e0e0e0',
              borderRadius: 2,
              boxShadow: 1
            }}
          >
            <Typography variant="h5" component="h2" gutterBottom>
              Dashboard
            </Typography>
            <Typography paragraph align="center">
              View your AI-powered cryptocurrency analysis and trading recommendations with real-time market data and insights.
            </Typography>
            <Button
              component={RouterLink}
              to="/dashboard"
              variant="contained"
              color="primary"
              sx={{ mt: 'auto' }}
            >
              Go to Dashboard
            </Button>
          </Box>
        )}

        <Box 
          sx={{ 
            p: 3, 
            flex: 1, 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            border: '1px solid #e0e0e0',
            borderRadius: 2,
            boxShadow: 1
          }}
        >
          <Typography variant="h5" component="h2" gutterBottom>
            Material UI
          </Typography>
          <Typography paragraph align="center">
            Build a beautiful UI with Material UI, a popular React UI framework that implements Google's Material Design.
          </Typography>
          <Button
            href="https://mui.com/material-ui/getting-started/"
            target="_blank"
            variant="contained"
            color="primary"
            sx={{ mt: 'auto' }}
          >
            Learn More
          </Button>
        </Box>
      </Box>

      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Current Environment: {env.appEnv}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          API URL: {env.apiUrl}
        </Typography>
      </Box>
    </Box>
  );
};

export default HomePage;
